// eslint-disable-next-line max-len
var USER_INTERFACE_CIRCLE_TICK_FILLED = 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm8.66,11.42L15.18,22.49a1.5,1.5,0,0,1-2.12.16L7.53,17.84h0a1.5,1.5,0,0,1,2-2.27l4.39,3.82,8.49-9.92a1.5,1.5,0,1,1,2.28,1.95Z';

export { USER_INTERFACE_CIRCLE_TICK_FILLED };
//# sourceMappingURL=USER_INTERFACE_CIRCLE_TICK_FILLED.js.map
